export default __webpack_public_path__ + "static/media/parkLong.9e3c3892.png";